import { useEffect, useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { useLoginAuth } from "@/hooks/useLoginAuth";
import { useUserStore } from "@/store/userStore";
import { supabase } from "@/integrations/supabase/client";
import { checkSuperAdmin } from "@/services/edgeFunctionWrappers/userRolesWrapper";
import { useNavigate } from "react-router-dom";

export const AuthRedirector = () => {
  const { user, loading } = useAuth();
  const { checkUserRole, isCheckingRole } = useLoginAuth();
  const role = useUserStore((s) => s.role);
  const setRole = useUserStore((s) => s.setRole);
  const navigate = useNavigate();
  const [superAdminChecked, setSuperAdminChecked] = useState(false);
  
  // Quick super admin check
  useEffect(() => {
    if (!loading && user && !role && !superAdminChecked) {
      const checkSuperAdminRole = async () => {
        try {
          // Verify valid session exists before checking role
          const { data: { session } } = await supabase.auth.getSession();
          if (!session) {
            console.log("AuthRedirector: No valid session, skipping super admin check");
            setSuperAdminChecked(true);
            return;
          }
          
          const isSuperAdmin = await checkSuperAdmin(user.id);
          setSuperAdminChecked(true);
          
          if (isSuperAdmin) {
            console.log("AuthRedirector: Super admin detected, redirecting");
            setRole('super_admin');
            navigate("/super-admin/dashboard", { replace: true });
          } else if (!isCheckingRole) {
            console.log("AuthRedirector: triggering role fetch for user", user.id);
            checkUserRole(user.id);
          }
        } catch (error) {
          console.error("AuthRedirector: Error checking super admin:", error);
          setSuperAdminChecked(true);
        }
      };
      
      checkSuperAdminRole();
    }
  }, [user, loading, role, isCheckingRole, checkUserRole, superAdminChecked, setRole, navigate]);
  
  return null;
};
